export default __webpack_public_path__ + "static/media/chrome-phone-2.1bf8b2d2.jpg";